module.exports = __webpack_public_path__ + "img/DlshadRawand-BerokakaniSarkawtn.30291266.jpg";